import { ReactNode } from 'react';
import AppHeader from '../UnauthenticatedHeader'
type Props = {
  children: ReactNode;
};

export default function WithoutHeaderLayout(props: Props) {
  const { children } = props;

  return <>
  <AppHeader/>
  {children}
  </>;
}
